import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function HeroSection({
  onCtaClick
}: {
  onCtaClick: () => void;
}) {
  return <section className="relative bg-[#FFF8F0] overflow-hidden pt-16 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-85">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none bg-[url('https://www.transparenttextures.com/patterns/paper.png')]" data-id="element-86"></div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-87">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-88">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center lg:text-left" data-id="element-89">
            <span className="inline-block py-1 px-3 rounded-full bg-[#D4A5A5]/20 text-[#8B7355] text-base font-serif italic mb-6 border border-[#D4A5A5]/30" data-id="element-90">
              El Manual Secreto de la Abuela
            </span>

            <h1 className="text-4xl md:text-6xl font-bold text-[#5C4033] font-serif mb-6 leading-tight" data-id="element-91">
              Antes, con menos, se resolvía todo. <br data-id="element-92" />
              <span className="text-[#9CAF88] italic" data-id="element-93">
                Volvé a tener soluciones reales en casa.
              </span>
            </h1>

            <p className="mt-6 text-xl text-[#6B5A4D] max-w-2xl mx-auto font-serif leading-relaxed" data-id="element-94">
              Soluciones simples, naturales y probadas para el hogar, el cuerpo
              y la vida cotidiana. Sin químicos innecesarios. Sin gastar de más.
              Sin complicaciones.
            </p>

            <p className="mt-4 text-lg text-[#8B7355] italic" data-id="element-95">
              El conocimiento práctico que pasó de generación en generación,
              reunido y adaptado para usar hoy.
            </p>

            <div className="mt-10 flex flex-col sm:flex-row lg:justify-start justify-center gap-4 items-center" data-id="element-96">
              <button onClick={onCtaClick} className="group bg-[#9CAF88] hover:bg-[#8A9F76] text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all shadow-lg hover:shadow-xl hover:-translate-y-1 flex items-center gap-2" data-id="element-97">
                Accedé ahora al Manual
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-98" />
              </button>

              <div className="flex items-center gap-2 text-[#6B5A4D] text-sm font-medium mt-4 sm:mt-0" data-id="element-99">
                <div className="flex -space-x-2" data-id="element-100">
                  {[1, 2, 3].map(i => <div key={i} className="w-8 h-8 rounded-full bg-[#D4A5A5] border-2 border-[#FFF8F0] flex items-center justify-center text-xs text-white" data-id="element-101">
                      ★
                    </div>)}
                </div>
                <span data-id="element-102">
                  Más de 10.000 mujeres ya lo usan para resolver su día a día
                </span>
              </div>
            </div>

            <div className="mt-8 flex lg:justify-start justify-center gap-6 text-sm text-[#8B7355]/80" data-id="element-103">
              <span className="flex items-center gap-1" data-id="element-104">
                ✓ Descarga inmediata
              </span>
              <span className="flex items-center gap-1" data-id="element-105">✓ 100% digital</span>
            </div>
          </motion.div>

          {/* Product Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative flex justify-center lg:justify-end" data-id="element-106">
            <img src="https://cdn.magicpatterns.com/uploads/pt8rL5HUuvWLFDqnuNLWRu/ChatGPT_Image_20_dic_2025,_05_20_25_p.m..png" alt="El Manual Secreto de la Abuela 2.0 en múltiples dispositivos" className="w-3/4 lg:w-4/5 h-auto rounded-2xl shadow-2xl" data-id="element-107" />
          </motion.div>
        </div>
      </div>
    </section>;
}